import { Currency } from 'api/domain/currency'

import { Optional } from '../app'

import { PaymentProvider } from './paymentProvider'
import { TransactionBase } from './baseTransaction'

export type IntegrationType = 'server' | 'hosted'
export type PaymentSource = 'user' | 'merchant'

export enum B2CTransactionType {
  purchase = 1,
  sale = 2,
  transfer = 3,
}

export const b2cTypesNaming: Record<B2CTransactionType, string> = {
  [B2CTransactionType.purchase]: 'Purchase',
  [B2CTransactionType.sale]: 'Sale',
  [B2CTransactionType.transfer]: 'Transfer',
}

/**
 * B2C transaction with all fields, used in admin endpoints
 */
export interface B2CTransactionRaw extends TransactionBase {
  type: B2CTransactionType
  provider_id: Optional<PaymentProvider>
  provider: Optional<PaymentProvider>
  b2b_tx_id: Optional<number>
  b2b_tx_uuid: Optional<string>
  b2c_fee_id: number

  source_amount: number
  source_currency: Currency
  destination_amount: number
  destination_currency: Currency

  fee: number
  spread_fee: number
  exchange_rate: Optional<number>

  recipient_user_id: number
  sender_user_id: number
}
